import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const paymentFormService = {
    async getAll(): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/payment-form/all`
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching payment form list:", error);
            throw error;
        }
    }
}

export default paymentFormService;